import script from "./captain.vue?vue&type=script&setup=true&lang=js"
export * from "./captain.vue?vue&type=script&setup=true&lang=js"

import "./captain.vue?vue&type=style&index=0&id=8dc755d0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dc755d0"]])

export default __exports__